import React from 'react';
import { makeStyles, Button } from '@material-ui/core';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

//workstation tile in the workstation overview
export default function CarpentryWorkstationTile(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    let history = useHistory();

    function showCarpentryPlanning() {
        props.actions.setSelectedCarpentryWorkstation(props.workstation.id);
        history.push("/carpentryWorkstation");
    }

    return (
        <React.Fragment>
            <div className={classes.workstation}>
                <div className={classes.line}>
                    {t("WORKSTATION")}
                </div>
                <div className={classes.lineId}>
                    {props.workstation.code}
                </div>
                <div className={classes.icon}>
                    <svg fill="#000000" width="100" height="100" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 459.249 459.249"><g><path d="M90.088,182.049l46.504-46.504c3.586-3.586,5.562-8.355,5.562-13.427s-1.976-9.841-5.562-13.428l-8.042-8.042 c-7.404-7.404-19.45-7.404-26.855,0l-46.504,46.504c-7.404,7.404-7.404,19.451,0,26.855l8.042,8.042 c3.702,3.702,8.565,5.553,13.428,5.553C81.523,187.602,86.386,185.751,90.088,182.049z M63.677,165.522 c-2.725-2.725-2.725-7.159,0-9.884l46.504-46.504c1.362-1.363,3.152-2.044,4.942-2.044c1.79,0,3.58,0.681,4.942,2.044l8.042,8.042 c1.32,1.32,2.047,3.075,2.047,4.942c0,1.867-0.727,3.622-2.047,4.942l-46.504,46.504c-2.724,2.727-7.159,2.726-9.884,0 L63.677,165.522z" /><path d="M458.901,231.69l-6.452-18.136c-7.354-20.676-19.227-39.877-34.427-55.722c2.366-15.752-2.69-31.893-13.581-42.783 c-10.882-10.881-27.001-15.94-42.742-13.586l-15.53-15.531l5.746-5.747c2.344-2.343,2.344-6.142,0-8.485l-28.524-28.524 c-2.342-2.343-6.143-2.343-8.484,0l-52.184,52.183c-2.344,2.343-2.344,6.142,0,8.485l28.524,28.525 c1.125,1.125,2.65,1.757,4.242,1.757c1.591,0,3.117-0.632,4.242-1.757l5.747-5.747l15.53,15.53 c-0.939,6.287-0.677,12.63,0.647,18.681l-62.709,62.708l-88.105-88.106c7.143-9.652,6.372-23.361-2.369-32.102l-50.65-50.65	c-4.661-4.661-10.857-7.228-17.448-7.228c-6.591,0-12.788,2.567-17.448,7.228L7.228,128.383C2.567,133.044,0,139.241,0,145.831 c0,6.591,2.567,12.788,7.228,17.448l50.65,50.65c4.811,4.811,11.129,7.216,17.449,7.216c4.366,0,8.72-1.176,12.588-3.473 l31.354,5.874l17.031,29.547c0.875,1.519,2.371,2.579,4.094,2.901l33.535,6.281l16.92,29.364l-83.872,83.871 c-9.615,9.615-9.553,25.322,0.139,35.014c4.868,4.868,11.252,7.303,17.623,7.303c6.307,0,12.599-2.39,17.383-7.173l94.935-94.935 l8.554,14.843c0.875,1.519,2.372,2.579,4.095,2.902l33.533,6.271l17.021,29.555c0.875,1.52,2.372,2.581,4.096,2.904l33.534,6.271 l17.031,29.556c0.875,1.519,2.37,2.579,4.094,2.902l36.24,6.79c0.367,0.069,0.737,0.103,1.104,0.103 c1.55,0,3.056-0.601,4.187-1.702l21.47-20.91c1.149-1.12,1.803-2.654,1.813-4.259s-0.622-3.147-1.758-4.282L294.091,258.686 l61.595-61.595c6.938,1.959,14.354,2.487,21.691,1.384c15.845,15.2,35.046,27.072,55.723,34.427l18.137,6.452 c0.656,0.234,1.336,0.347,2.01,0.347c1.565,0,3.099-0.613,4.244-1.757C459.128,236.306,459.678,233.872,458.901,231.69z M295.489,119.641l-20.039-20.04l43.698-43.698l20.039,20.039L295.489,119.641z M66.363,205.445l-50.65-50.65 C13.318,152.4,12,149.217,12,145.831s1.319-6.569,3.713-8.963L91.412,61.17c2.394-2.394,5.577-3.713,8.963-3.713 s6.569,1.319,8.963,3.713l50.65,50.65c4.942,4.942,4.942,12.983,0,17.926l-75.724,75.722 C79.319,210.385,71.297,210.38,66.363,205.445z M182.947,253.893c-0.875-1.519-2.371-2.579-4.094-2.902l-33.535-6.282 l-17.031-29.547c-0.875-1.519-2.371-2.579-4.093-2.901l-25.056-4.694l63.432-63.432l87.893,87.893l-50.827,50.827L182.947,253.893z M409.286,390.852l-14.884,14.496l-30.465-5.708l-17.031-29.557c-0.875-1.52-2.371-2.58-4.095-2.902l-33.533-6.271l-17.021-29.555 c-0.875-1.52-2.372-2.581-4.096-2.904l-33.534-6.271l-8.785-15.244l39.764-39.764L409.286,390.852z M133.636,402.172 c-4.936,4.937-13.027,4.877-18.035-0.13c-5.013-5.013-5.076-13.107-0.139-18.043l210.681-210.681 c2.215,4.258,5.049,8.174,8.453,11.578c2.758,2.758,5.855,5.139,9.195,7.123L133.636,402.172z M437.122,221.597 c-20.003-7.116-38.511-18.812-53.522-33.823c-1.137-1.137-2.668-1.757-4.242-1.757c-0.423,0-0.849,0.044-1.271,0.136 c-12.81,2.774-26.221-0.958-35.006-9.743c-8.784-8.785-12.518-22.198-9.741-35.005c0.432-1.994-0.179-4.071-1.622-5.514 l-17.504-17.504l23.721-23.72l17.504,17.504c1.442,1.442,3.517,2.056,5.514,1.621c12.805-2.775,26.22,0.956,35.005,9.742 c8.786,8.786,12.52,22.199,9.742,35.005c-0.432,1.994,0.179,4.071,1.622,5.514c15.012,15.012,26.708,33.52,33.822,53.522 l2.221,6.241L437.122,221.597z" /></g></svg>
                </div>
            </div>
            <div className={classes.buttonContainer}>
                <Button className={classes.carpentryButton} onClick={showCarpentryPlanning}>{t("SHOW PLANNING")}</Button>
            </div>
        </React.Fragment>


    )
}

const useStyles = makeStyles(() => ({
    line: {
        color: "#8D8D8D",
        fontSize: "15px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingTop: "25px",
        paddingBottom: "5px"

    },
    lineId: {
        color: "#000000",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingBottom: "10px"
    },
    icon: {
        color: "#000000",
        textAlign: "center",
        paddingBottom: "10px"
    },
    workstation: {
        width: "200px",
        height: "220px",
        backgroundColor: "white",
        borderRadius: "6px",
        padding: "20px",

        boxShadow: "0px 3px 15px rgba(0,0,0,0.1)",

        // box-shadow: 0px 3px 15px rgba(0,0,0,0.1);
    },
    carpentryButton: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        width: "200px",
        marginTop: "50px",
        height: "40px",
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        "&:hover": {
            background: FlagstoneTheme.palette.primary.main
        },
    },
    buttonContainer: {
        width: "100%",
        textAlign: "center",
        marginBottom: "50px"
    }
}));